import { getClientInstallationById } from '@api/services/client-installation.service';
import { getClientById } from '@api/services/client.service';
import useDataQuery from '@hooks/use-data-query';

const useClientInstallationData = (clientInstallationId: string) => {
    const clientInstallationQuery = useDataQuery(
        ['client-installation', clientInstallationId],
        () => getClientInstallationById(clientInstallationId),
        {
            enabled: Boolean(clientInstallationId),
        }
    );

    return {
        isLoading: clientInstallationQuery.isLoading,
        clientInstallation: clientInstallationQuery.data,
        setData: clientInstallationQuery.setData,
    };
};

export default useClientInstallationData;
